import axios from "axios";
import { ReferenceTable } from "../../types/interfaces/admin/ReferenceResponse";
import { SessionStore } from "../../types/store";
import { getReferenceRoute, newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/reference-values`;

export const reorderReferenceValues = async (
  tables: ReferenceTable[],
  schema: string,
  table: string,
  orderedIds: number[],
) => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const route = getReferenceRoute(tables, schema, table);

  return axios.put(
    `${BASE_URL}/${route}`,
    { orderedIds: orderedIds },
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );
};
